document.addEventListener('DOMContentLoaded', function () {
  function isMobile() {
    return window.innerWidth <= 750;
  }

  document.querySelectorAll('.main-image-arrows-container').forEach(function (wrapper) {
    const slider = wrapper.querySelector('.product__media-list');
    const slides = Array.from(slider.querySelectorAll('.product__media-item'));
    const prevBtn = wrapper.querySelector('.slider-button--prev.main-image-arrow');
    const nextBtn = wrapper.querySelector('.slider-button--next.main-image-arrow');
    const thumbnails = document.querySelectorAll('.thumbnail-list__item button');

    let current = slides.findIndex(slide => slide.classList.contains('is-active'));
    if (current === -1) current = 0;

    function updateSlider(newIndex) {
      // Update main image
      slides[current].classList.remove('is-active');
      slides[newIndex].classList.add('is-active');

      // Update thumbnail accessibility
      thumbnails.forEach((thumbBtn, i) => {
        if (i === newIndex) {
          thumbBtn.setAttribute('aria-current', 'true');
        } else {
          thumbBtn.removeAttribute('aria-current');
        }
      });

      current = newIndex;

      // For mobile, scroll the slider horizontally if needed
      if (isMobile()) {
        slider.scrollTo({
          left: slides[newIndex].offsetLeft - slider.offsetLeft,
          behavior: 'smooth'
        });
      }
    }

    prevBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      let newIndex = current - 1;
      if (newIndex < 0) newIndex = slides.length - 1;
      updateSlider(newIndex);
    });

    nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      let newIndex = current + 1;
      if (newIndex >= slides.length) newIndex = 0;
      updateSlider(newIndex);
    });
  });
});